export const debugMode = false
export const production = true
export const apiHost =  production ? "https://apimemorize.hello2531.workers.dev/" : "https://apimemorize.hello2531.workers.dev/"
export const precision = 9
export const maintenance = false
export const showTabbar = false